import { BaseBlock } from "./BaseBlock";

import type { AppState } from "../app/state/AppState";


type Sticker =
    NonNullable<
        AppState["stickers"]
    >[number];

export class StickerCardBlock
    extends BaseBlock {

    private readonly sticker: Sticker;

    private readonly onStickerSelected:
    (stickerId: string) => void;

    private root!: HTMLElement;

    constructor(
        sticker: Sticker,
        onStickerSelected: (
            stickerId: string
        ) => void
    ) {

        super();

        this.sticker = sticker;

        this.onStickerSelected =
            onStickerSelected;

    }

    public override mount(): void {

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =====================================================

    private buildRoot(): HTMLElement {

        const card =
            document.createElement("div");

        card.className =
            "sticker-card";

        // =====================================
        // TITLE
        // =====================================

        const title =
            document.createElement("h3");

        title.textContent =
            this.sticker.title;

        card.appendChild(
            title
        );

        // =====================================
        // DESCRIPTION
        // =====================================

        const description =
            document.createElement("div");

        description.className =
            "description";

        description.innerHTML =
            this.sticker.description;

        card.appendChild(
            description
        );

         // =====================================
        // BUTTON
        // =====================================

        const button =
            document.createElement("button");

        button.type =
            "button";

        if (this.sticker.renewal_active) {

            button.className =
                "subscription-button current-subscription";

            button.disabled =
                true;

        } else {

            button.className =
                "subscription-button";

            button.addEventListener(
                "click",
                (event) => {

                    event.preventDefault();

                    event.stopPropagation();

                    this.onStickerSelected(
                        this.sticker.sticker_id
                    );

                }
            );

        }

        // =====================================
        // BUTTON TEXT
        // =====================================

        const caption =
            document.createElement("div");

        caption.textContent =

            this.sticker.renewal_active

                ? "Поточна підписка"

                : this.sticker.payment_description;

            if (this.sticker.renewal_active) {

                    caption.className =
                        "current-subscription-caption";

                }

        button.appendChild(
            caption
        );

        // =====================================
        // PRICE ROW
        // =====================================

        const priceRow =
            document.createElement("div");

        if (

            this.sticker.discounted_price_uah
            <
            this.sticker.full_price_uah

        ) {

            const oldPrice =
                document.createElement("span");

            oldPrice.className =
                "old-price-uah";

            oldPrice.textContent =
                String(
                    this.sticker.full_price_uah
                );

            priceRow.appendChild(
                oldPrice
            );

        }

        const newPrice =
            document.createElement("span");

        newPrice.className =
            "new-price";

        newPrice.textContent =
            `${this.sticker.discounted_price_uah} Грн.`;

        priceRow.appendChild(
            newPrice
        );

        button.appendChild(
            priceRow
        );

        card.appendChild(
            button
        );

        return card;

    }

}